import React, { useState, useMemo, memo } from "react"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import Popper from "@material-ui/core/Popper"
import globalUseStyles from "@/globalUseStyles"
import clsx from "clsx"
import { useSelector, useDispatch } from "react-redux"
import modalStatusHandler from "@/redux/actions/modalAction"
import { getUserTopRole, urlPath } from "@/utils"
import { resetActivateProcess } from "@/redux/actions/activateProjectProcessAction"
import { useNavigate, useLocation } from "react-router-dom"
import ProjectFilterDropdown from "./ProjectFilterDropdown"
import SidebarDropdown from "./SidebarDropdown"
import { Collapse, Divider, Drawer, IconButton, List, ListItem, ListItemIcon, ListItemText, Tooltip } from "@material-ui/core"
import { AddBoxOutlined, AddShoppingCartOutlined, ApartmentOutlined, DashboardOutlined, ExpandLessOutlined, ExpandMoreOutlined, ExtensionOutlined, GridOffOutlined, HomeOutlined, InboxOutlined, Mail, MailOutlineOutlined, MenuOutlined, StarBorderOutlined, WorkOutline } from '@material-ui/icons'
import useTopRoleIsAccountHolder from "@/hooks/useTopRoleIsAccountHolder"
import IconMyProjectsPrimary from '../../assets/images/project-dashboard-primary.png'
import IconMyProjectsLight from '../../assets/images/project-dashboard-light.png'
import CustomRasterIcon from "../common/CustomRasterIcon"
import { useCallback } from "react"


const drawerWidth = 260;
const useStyles = makeStyles((theme) => ({
    sidebarButton: {
        marginBottom: theme.spacing(4),
        // width: "120px"
    },
    filterButton: {
        position: "relative",
        backgroundColor: "#ffffff",
        "&.dropdown-close::after": {
            content: '""',
            width: 0,
            height: 0,
            borderLeft: "7px solid transparent",
            borderRight: "7px solid transparent",
            borderTop: "7px solid #000",
            position: "absolute",
            right: "10px",
            top: "14px",
        },
        "&.dropdown-open::after": {
            content: '""',
            width: 0,
            height: 0,
            borderLeft: "7px solid transparent",
            borderRight: "7px solid transparent",
            borderBottom: "7px solid #000",
            position: "absolute",
            right: "10px",
            top: "14px",
        },
        "&:hover": {
            backgroundColor: "#cc2429",
            borderColor: "#cc2429",
        },
    },
    popper: {
        borderRadius: "4px",
        boxShadow: "0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)",
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
    // Added 
    hide: {
        display: "none"
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        padding: '16px'
    },
    drawerWrapper: {
        // padding: 8,
        textTransform: "uppercase",
        fontSize: "12px"

    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: "hidden",
        width: theme.spacing(10),
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(12)
        }
    },
    clearfix: {
        // marginTop: "12px"
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        marginTop: theme.spacing(),
        justifyContent: "flex-end",
        padding: "0 8px",
        ...theme.mixins.toolbar
    },
    subList: {
        fontSize: 0.8,
        background: "#ececec"
    }
}))

const MuiListItem = withStyles((theme) => ({
    root: {
        "&$selected": {
            backgroundColor: "red",
            color: "white",
            "& .MuiListItemIcon-root": {
                color: "white"
            }
        },
        "&$selected:hover": {
            backgroundColor: theme.palette.primary.main,
            color: "white",
            "& .MuiListItemIcon-root": {
                color: "white"
            }
        },
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: "white",
            "& .MuiSvgIcon-root": {
                color: "white !important"
            }
        }
    },
    selected: {}
}))(ListItem);

const Sidebar = () => {
    const classes = useStyles()
    const navigate = useNavigate()
    const location = useLocation()
    const path = location.pathname
    const viewDepartmentPath = path.includes("view-department")
    const viewDesignationPath = path.includes("view-designation")
    const globalClasses = globalUseStyles()
    const dispatch = useDispatch()
    const userRoleData = useSelector((state) => state.userRoleReducer)
    const userData = useSelector((state) => state.userReducer)
    const { drawerOpen } = useSelector((state) => state.drawerReducer)
    const { user } = userData
    const { userRolesArray } = userRoleData
    const loginUserRoles = userRolesArray.find((userRoleItem) => userRoleItem.userId === user.userId).userRoles
    const topRole = useMemo(() => getUserTopRole(loginUserRoles), userRolesArray)
    // detect if role is project manager or account holder, if it is, show add project button
    const managerRole = topRole.roleName === process.env.PROJECT_MANAGER
    const accountHolderRole = topRole.roleName === process.env.ACCOUNT_HOLDER
    const [anchorEl, setAnchorEl] = useState(null)
    const [open, setOpen] = useState(false)
    const [placement, setPlacement] = useState()

    const topRoleIsAccountHolder = useTopRoleIsAccountHolder(userData)

    const handleClick = (newPlacement) => (event) => {
        setAnchorEl(event.currentTarget)
        setOpen((prev) => placement !== newPlacement || !prev)
        setPlacement(newPlacement)
    }


    const [anchorElProjectFilter, setAnchorElProjectFilter] = useState(null)
    const [openProjectFilter, setOpenProjectFilter] = useState(false)
    const [placementProjectFilter, setPlacementProjectFilter] = useState()

    const handleClickProjectFilter = (newPlacement) => (event) => {
        setAnchorElProjectFilter(event.currentTarget)
        setOpenProjectFilter((prev) => placementProjectFilter !== newPlacement || !prev)
        setPlacementProjectFilter(newPlacement)
    }

    const handleAddProject = () => {
        setOpen(false)
        dispatch(
            modalStatusHandler({
                modalProjectId: null,
                currentStep: 1,
                modalShow: true,
            })
        )
        dispatch(resetActivateProcess)
    }

    const navigateToPage = (path) => {
        setOpen(false)
        setOpenProjectFilter(false)
        navigate(path)
    }

    const id = (filterOpen) => (filterOpen ? "simple-popover" : undefined)
    const openStatus = (filterOpen) => (filterOpen ? "dropdown-open" : "dropdown-close")

    const productData = useSelector((state) => state.productReducer)
    const { customerDataCulture, sparcaProducts } = productData;

    const [myProjectsIcon, setMyProjectsIcon] = useState(IconMyProjectsPrimary)

    const changeMyProjectsIcon = useCallback((type) => {
        if(type === 'dark'){
            setMyProjectsIcon(IconMyProjectsPrimary)
        }else if(type === 'light'){
            setMyProjectsIcon(IconMyProjectsLight)
        }
    }, [myProjectsIcon])

    return (
        <Drawer
            variant="permanent"
            className={`${classes.drawerWrapper}`, clsx(classes.drawer, {
                [classes.drawerOpen]: drawerOpen,
                [classes.drawerClose]: !drawerOpen
            })}
            classes={{
                paper: clsx({
                    [classes.drawerOpen]: drawerOpen,
                    [classes.drawerClose]: !drawerOpen
                })
            }}
            open={drawerOpen}
        >
            <Box className={classes.clearfix}></Box>

            <div className={classes.toolbar} />
            <List>
                {accountHolderRole &&
                    <Tooltip title="Home" placement="right-end">
                        <MuiListItem button onClick={() => navigateToPage(urlPath("account-holder-main", user.userId))}>
                            <ListItemIcon color="primary">
                                <HomeOutlined color="primary" />
                            </ListItemIcon>
                            <ListItemText primary="Home" />
                        </MuiListItem>
                    </Tooltip>
                }
                <Tooltip title="Manage Projects" placement="right-end">
                    <MuiListItem onMouseOver={() => changeMyProjectsIcon('light')} onMouseLeave={() => changeMyProjectsIcon('dark')} button onClick={() => navigateToPage(urlPath("dashboard", user.userId))}>
                        <ListItemIcon color="primary">
                            <CustomRasterIcon image={myProjectsIcon} size={24} /> 
                        </ListItemIcon>
                        <ListItemText primary="Project Dashboard" />
                    </MuiListItem>
                </Tooltip>
                {accountHolderRole || managerRole ? (
                    <>
                        <Tooltip title="Manage Departments" placement="right-end">
                            <MuiListItem button onClick={() => navigateToPage(urlPath("view-department", user.userId))}>
                                <ListItemIcon color="primary">
                                    <ApartmentOutlined color="primary" />
                                </ListItemIcon>
                                <ListItemText primary="Departments" />
                            </MuiListItem>
                        </Tooltip>

                        {/* Enable to go to designaions page */}
                        {/* <Tooltip title="Manage Designaions" placement="right-end">
                            <MuiListItem button onClick={() => navigateToPage(urlPath("view-designation", user.userId))}>
                                <ListItemIcon>
                                    <WorkOutline color="primary" />
                                </ListItemIcon>
                                <ListItemText primary="Designations" />
                            </MuiListItem>
                        </Tooltip> */}

                        {/* <Divider/> */}

                        <Tooltip title="Start a new Project" placement="right-end">
                            <MuiListItem button onClick={handleAddProject}>
                                <ListItemIcon>
                                    <AddBoxOutlined color="primary" />
                                </ListItemIcon>
                                <ListItemText primary="Start Project" />
                            </MuiListItem>
                        </Tooltip>
                    </>
                ) : null}
                
                {/* The below component renders a list of SPARCA products and shows what product a company is subscribed to */}
                {/* {accountHolderRole && (
                    <SidebarDropdown />
                )} */}
                <Divider />
            </List>
        </Drawer>
    )
}

export default Sidebar
